import localCache from "@/utils/local_storage";
import Cookies from 'js-cookie';

const ACCESS_TOKEN = 'Access-Token'

// 获取缓存的token（同时检查localStorage和Cookies）
const getAccessToken = () => {
    return localCache.get(ACCESS_TOKEN) || Cookies.get(ACCESS_TOKEN) || ''
}

// 设置缓存的token（同时存入localStorage和Cookies）
const setAccessToken = (token) => {
    // 设置过期时间为7天
    const expires = new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000);
    Cookies.set(ACCESS_TOKEN, token, { expires });
    return localCache.set(ACCESS_TOKEN, token)
}

// 删除缓存的token（同时从localStorage和Cookies中删除）
const removeAccessToken = () => {
    Cookies.remove(ACCESS_TOKEN);
    return localCache.remove(ACCESS_TOKEN)
}

export { getAccessToken, setAccessToken, removeAccessToken }
